import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { TaskItem } from "../../../backend/backendapi";

@Component({
    name: 'TaskComponent',
    components: {}
})
export default class TaskComponent extends Vue {
    @Prop({ required: true })
    task!: TaskItem;
    @Prop({ default: false })
    readonly!: boolean;
    @Prop({ default: false })
    lockeddown!: boolean;

    private toggle(checked: boolean): void {
        this.$emit('toggle', this.task, checked);
    }

    private edit(): void {
        this.$emit('edit', this.task);
    }

    private remove(): void {
        this.$emit('remove', this.task);
    }
}
